import { jsx as n, jsxs as s, Fragment as h } from "react/jsx-runtime";
import * as t from "react";
import { c as i } from "../../index-C3-ZVs5E.js";
import '../../assets/Checkbox.css';const _ = "_label_1yf37_2", C = "_icon_1yf37_16", m = "_checkedIcon_1yf37_21", w = "_uncheckedIcon_1yf37_24", k = "_switchContainer_1yf37_28", f = "_switchIcon_1yf37_36", p = "_checked_1yf37_21", I = "_input_1yf37_57", c = {
  label: _,
  switch: "_switch_1yf37_12",
  icon: C,
  checkedIcon: m,
  uncheckedIcon: w,
  switchContainer: k,
  switchIcon: f,
  checked: p,
  input: I
}, y = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM6.22446 9.38392L10.5309 5.17423L10.5315 5.17489C10.6074 5.10075 10.65 5.00019 10.65 4.89534C10.65 4.79049 10.6074 4.68993 10.5315 4.61579C10.4557 4.54165 10.3528 4.5 10.2456 4.5C10.1383 4.5 10.0354 4.54165 9.9596 4.61579L5.93882 8.5456L4.3404 6.98308C4.30285 6.94637 4.25826 6.91725 4.20919 6.89739C4.16013 6.87752 4.10754 6.86729 4.05443 6.86729C4.00132 6.86729 3.94873 6.87752 3.89966 6.89739C3.85059 6.91725 3.80601 6.94637 3.76845 6.98308C3.7309 7.0198 3.70111 7.06338 3.68079 7.11134C3.66046 7.15931 3.65 7.21072 3.65 7.26263C3.65 7.31455 3.66046 7.36596 3.68079 7.41393C3.70111 7.46189 3.7309 7.50547 3.76845 7.54218L5.65251 9.38392C5.69002 9.42071 5.73459 9.44991 5.78366 9.46983C5.83273 9.48975 5.88535 9.5 5.93848 9.5C5.99162 9.5 6.04423 9.48975 6.09331 9.46983C6.14238 9.44991 6.18695 9.42071 6.22446 9.38392Z", fill: "black" })), u = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...e }, /* @__PURE__ */ t.createElement("circle", { cx: 7, cy: 7, r: 6.5, transform: "rotate(-180 7 7)", stroke: "black", strokeOpacity: 0.5 })), x = ({
  checked: e,
  label: l,
  isSwitch: o,
  className: r,
  ...d
}) => {
  const a = o ? /* @__PURE__ */ n("div", { className: c.switchContainer, children: /* @__PURE__ */ n("div", { className: c.switchIcon }) }) : e ? /* @__PURE__ */ n(y, { className: i(c.icon, c.checkedIcon) }) : /* @__PURE__ */ n(
    u,
    {
      className: i(c.icon, c.uncheckedIcon)
    }
  );
  return /* @__PURE__ */ s(
    "label",
    {
      className: i(c.label, r, {
        [c.checked]: e,
        [c.switch]: o
      }),
      children: [
        /* @__PURE__ */ n(
          "input",
          {
            type: "checkbox",
            checked: e,
            ...d,
            className: c.input
          }
        ),
        o ? /* @__PURE__ */ s(h, { children: [
          l,
          a
        ] }) : /* @__PURE__ */ s(h, { children: [
          a,
          l
        ] })
      ]
    }
  );
};
export {
  x as Checkbox
};
